module.exports = __webpack_public_path__ + "media/asset/images/comlogo-e191222d98fe602d6232c15236eefe69.png";